/**
 * Geometry of an `object-fit: cover` content box inside a container.
 *
 * Shared by VideoQuic (to position the overlay canvas) and the blur worker
 * (to convert the display-pixel blur radius into source pixels). Both must
 * agree, so this lives in one place.
 */
export interface CoverBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function objectFitCoverBox(
  containerW: number,
  containerH: number,
  mediaW: number,
  mediaH: number
): CoverBox {
  if (containerW <= 0 || containerH <= 0 || mediaW <= 0 || mediaH <= 0) {
    return { left: 0, top: 0, width: containerW, height: containerH };
  }
  const scale = Math.max(containerW / mediaW, containerH / mediaH);
  const width = mediaW * scale;
  const height = mediaH * scale;
  return {
    left: (containerW - width) / 2,
    top: (containerH - height) / 2,
    width,
    height,
  };
}
